import React, { useEffect, useRef } from 'react';
import './ContextMenu.css';

const ContextMenu = ({ position, actions, onClose }) => {
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        onClose();
      }
    };
    const handleEsc = (e) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('keydown', handleEsc);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleEsc);
    };
  }, [onClose]);

  // Adjust so menu doesn't overflow viewport
  const style = {
    left: Math.min(position.x, window.innerWidth - 200),
    top: Math.min(position.y, window.innerHeight - actions.length * 40 - 16),
  };

  return (
    <div className="context-menu" ref={menuRef} style={style}>
      {actions.map((action, i) =>
        action.separator ? (
          <div key={i} className="context-menu-separator" />
        ) : (
          <button
            key={i}
            className={`context-menu-item${action.danger ? ' danger' : ''}`}
            onClick={() => {
              action.action();
              onClose();
            }}
          >
            {action.icon && <span className="context-menu-icon">{action.icon}</span>}
            {action.label}
          </button>
        )
      )}
    </div>
  );
};

export default ContextMenu;
